import RESOURCE_CATEGORIES from './resourceCategory';
import RESOURCE_CATEGORY_DISPLAY_NAMES from './resourceCategoryDisplayNames';

export const categoryOptions = [
  {
    title: RESOURCE_CATEGORY_DISPLAY_NAMES[RESOURCE_CATEGORIES.GETTING_STARTED].name,
    value: RESOURCE_CATEGORIES.GETTING_STARTED
  },
  {
    title: RESOURCE_CATEGORY_DISPLAY_NAMES[RESOURCE_CATEGORIES.APPRAISAL_VALUE].name,
    value: RESOURCE_CATEGORIES.APPRAISAL_VALUE
  },
  {
    title: RESOURCE_CATEGORY_DISPLAY_NAMES[RESOURCE_CATEGORIES.VIP_ENGAGEMENT].name,
    value: RESOURCE_CATEGORIES.VIP_ENGAGEMENT
  }
];
